import { TFunction } from "i18n";
import { SocialMediaPlatformCode } from "shared-types";
import { SocialMediaPillType } from "../SocialMediaPill";

export function getSubscribersText(n: number) {
  if (n < 100) return "< 100";

  if (n < 1000) return "> 100";

  const rounded = Math.floor(n / 100) * 100;
  const value = rounded / 1000;

  return `${Number(value.toFixed(1))}K`;
}

export function getSocialPillText({
  t,
  type,
  variant,
  subscribersCount,
}: {
  t: TFunction;
  type?: SocialMediaPillType;
  variant: SocialMediaPlatformCode;
  subscribersCount: number;
}) {
  switch (type) {
    case SocialMediaPillType.Connect:
      return t(
        `performer:profile.socialMedia.pill.label.connect.${variant.toLowerCase()}`
      );
    case SocialMediaPillType.Connected:
      return t("performer:profile.socialMedia.pill.connected");
    case SocialMediaPillType.Subscribers: {
      return t("performer:profile.socialMedia.pill.followers", {
        subscribers: getSubscribersText(subscribersCount),
      });
    }
    default:
      return;
  }
}
